import SetIsActive from '@/common/components/SetIsActive'
import useMutationUpdateDepositPromotion from '@/modules/promotion/api/hooks/useMutateUpdateDepositPromotion'
import { DepositPromotionQueryKeys } from '@/modules/promotion/keys'
import { GetDepositPromotionResponseData } from '@/modules/promotion/type'
import { useQueryClient } from '@tanstack/react-query'

interface IsActiveDepositPromotionProps {
	row: GetDepositPromotionResponseData
}

export function IsActiveDepositPromotion({
	row,
}: IsActiveDepositPromotionProps) {
	const { mutateAsync: updateDepositPromotion } =
		useMutationUpdateDepositPromotion()
	const queryClient = useQueryClient()

	const handleMutate = async (value: boolean) => {
		await updateDepositPromotion(
			{
				id: row.id,
				payload: {
					isActive: value,
				},
			},
			{
				onSuccess: () => {
					queryClient.invalidateQueries({
						queryKey: [DepositPromotionQueryKeys.GetDepositPromotionList],
					})
				},
			},
		)
	}

	return (
		<SetIsActive
			defaultChecked={row.isActive}
			onMutate={handleMutate}
			errorMessage="ไม่สามารถอัพเดทสถานะได้"
		/>
	)
}
